<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center flex-grow-1"
  >
    <div class="text-center">
      <font-awesome-icon
        :icon="['far', 'exclamation-triangle']"
        size="3x"
        class="mb-4 text-danger"
      />
      <p>
        {{ $t("not_allowed.message") }}
        <br />
        {{ $t("not_allowed.contact") }}
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NotAllowed",
  };
</script>
